"use strict";
import { INTERNAL_ROUTER_PREFERENCE_PRICE, RouterPreference, URAQuoteType } from "state/routing/types";
import { currencyAddressForSwapQuote } from "state/routing/utils";
import { UniverseChainId } from "uniswap/src/features/chains/types";
export function createGetRoutingAPIArguments(ctx) {
  const { canUseUniswapX, isPriorityOrdersEnabled, isDutchV3Enabled } = ctx;
  return function getRoutingAPIArguments(input) {
    if (!validateRoutingAPIInput(input)) {
      throw new Error(`Invalid routing API input: ${JSON.stringify(input)}`);
    }
    const { account, tokenIn, tokenOut, amount, tradeType, routerPreference, protocolPreferences } = input;
    const sendPortionEnabled = routerPreference !== INTERNAL_ROUTER_PREFERENCE_PRICE;
    const isPriorityOrder = routerPreference === RouterPreference.X && isPriorityOrdersEnabled;
    const isArbitrum = tokenIn?.chainId === UniverseChainId.ArbitrumOne;
    const routingType = getRoutingType({
      canUseUniswapX,
      isPriorityOrder,
      isArbitrum,
      isDutchV3Enabled
    });
    return {
      account,
      amount: amount.quotient.toString(),
      tokenInAddress: currencyAddressForSwapQuote(tokenIn),
      tokenInChainId: tokenIn.chainId,
      tokenInDecimals: tokenIn.wrapped.decimals,
      tokenInSymbol: tokenIn.wrapped.symbol,
      tokenOutAddress: currencyAddressForSwapQuote(tokenOut),
      tokenOutChainId: tokenOut.wrapped.chainId,
      tokenOutDecimals: tokenOut.wrapped.decimals,
      tokenOutSymbol: tokenOut.wrapped.symbol,
      routerPreference,
      protocolPreferences,
      tradeType,
      needsWrapIfUniswapX: tokenIn.isNative,
      uniswapXForceSyntheticQuotes: false,
      sendPortionEnabled,
      routingType
    };
  };
}
export function validateRoutingAPIInput(input) {
  return !!input.tokenIn && !!input.tokenOut && !!input.amount && !input.tokenIn.equals(input.tokenOut) && !input.tokenIn.wrapped.equals(input.tokenOut.wrapped);
}
function getRoutingType(input) {
  const { canUseUniswapX, isPriorityOrder, isArbitrum, isDutchV3Enabled } = input;
  if (!canUseUniswapX) {
    return URAQuoteType.CLASSIC;
  }
  if (isPriorityOrder) {
    return URAQuoteType.PRIORITY;
  }
  if (isArbitrum) {
    return isDutchV3Enabled ? URAQuoteType.DUTCH_V3 : URAQuoteType.DUTCH_V1;
  }
  return URAQuoteType.DUTCH_V2;
}
